@if (!isPreview) {
  <section>
    <div class="header">
      <h1>{{ 'LEASE_AGREEMENT.RENTAL_CHANGES_HEADER' | translate }}</h1>
      <button class="btn btn-active btn-list-header" (click)="preview()">{{ 'PREVIEW_BTN' | translate }}</button>
    </div>
    <div class="row">
      <div class="col-6 col-md-3 form-group">
        <app-date-picker
          [form]="form.controls['fromDate']"
          [isRequired]="true"
          [title]="'LEASE_AGREEMENT.RENTAL_CHANGES_FROM'"
          [model]="fromDate"
          [helpText]="'LEASE_AGREEMENT.HELP_TEXT.RENTAL_CHANGES_FROM'"
        ></app-date-picker>
      </div>
      <div class="col-12 col-md-5 col-lg-4">
        <app-check-box [control]="roundPeriodRent" [helpText]="'LEASE_AGREEMENT.HELP_TEXT.RENTAL_CHANGES_ROUND_PERIOD_RENT'"></app-check-box>
      </div>
    </div>
    <div class="row">
      <div class="col-6 col-md-3 form-group">
        <app-numeric-box [control]="rentalChangeValue" [helpText]="'LEASE_AGREEMENT.HELP_TEXT.RENTAL_CHANGES_VALUE'"></app-numeric-box>
      </div>
      <div class="col-6 col-md-3 form-group">
        <app-select
          [control]="rentalChangeUnit"
          [itemsSource]="rentalChangeUnits"
          [helpText]="'LEASE_AGREEMENT.HELP_TEXT.RENTAL_CHANGES_UNIT'"
        ></app-select>
      </div>
      <div class="col-6 col-md-4 form-group">
        <app-select [control]="form.controls['adjustmentType']" [itemsSource]="adjustmentSelection"></app-select>
      </div>
    </div>
    <h4 class="mb-2">
      <span class="d-inline-block">
        <app-help-text [dataContext]="'LEASE_AGREEMENT.HELP_TEXT.RENTAL_CHANGES_ARTICLES'"></app-help-text>
        <span class="mr-4">{{ 'ARTICLE_LIST.HEADER' | translate }}</span>
      </span>
    </h4>
    <app-multiselect-list-view
      [itemsSource]="articles"
      [columnDefinition]="articleColumnDefinitions"
      [selectAll]="true"
      [preferencesKey]="'rent.rental-changes.articles'"
      >
    </app-multiselect-list-view>
    <h4>
      <span class="d-inline-block">
        <span class="mr-4">{{ 'LEASE_AGREEMENT.RENTAL_CHANGES_RETRO_CAPTION' | translate }}</span>
      </span>
    </h4>
    <div class="row">
      <div class="col-12 col-md-5 col-lg-4">
        <app-toogle [control]="useRetroactiveRent"></app-toogle>
      </div>
    </div>
    @if (this.form.controls['useRetroactiveRent'].value) {
      <div class="row">
        <div class="col-6 col-md-4">
          <app-date-picker
            [form]="form.controls['missedPeriodFromDate']"
            [title]="'LEASE_AGREEMENT.RENTAL_CHANGES_MISSED_FROM'"
            [model]="missedPeriodFromDate"
            [helpText]="'LEASE_AGREEMENT.HELP_TEXT.RENTAL_CHANGES_MISSED_FROM'"
          ></app-date-picker>
        </div>
        <div class="col-6 col-md-4">
          <app-date-picker
            [form]="form.controls['missedPeriodToDate']"
            [title]="'LEASE_AGREEMENT.RENTAL_CHANGES_MISSED_TO'"
            [model]="missedPeriodToDate"
            [helpText]="'LEASE_AGREEMENT.HELP_TEXT.RENTAL_CHANGES_MISSED_TO'"
          ></app-date-picker>
        </div>
      </div>
    }
    @if (this.form.controls['useRetroactiveRent'].value) {
      <div class="row">
        <div class="col-6 col-md-4">
          <app-date-picker
            [form]="form.controls['retroInvoiceFromDate']"
            [title]="'LEASE_AGREEMENT.RENTAL_CHANGES_RETRO_FROM'"
            [model]="retroInvoiceFromDate"
            [helpText]="'LEASE_AGREEMENT.HELP_TEXT.RENTAL_CHANGES_RETRO_FROM'"
          ></app-date-picker>
        </div>
        <div class="col-6 col-md-4">
          <app-date-picker
            [form]="form.controls['retroInvoiceToDate']"
            [title]="'LEASE_AGREEMENT.RENTAL_CHANGES_RETRO_TO'"
            [model]="retroInvoiceToDate"
            [helpText]="'LEASE_AGREEMENT.HELP_TEXT.RENTAL_CHANGES_RETRO_TO'"
          ></app-date-picker>
        </div>
      </div>
    }
    @if (this.form.controls['useRetroactiveRent'].value) {
      <div class="row">
        <div class="col-12 col-md-5 col-lg-4">
          <app-check-box
            [control]="changeInvoiceText"
            [helpText]="'LEASE_AGREEMENT.HELP_TEXT.RENTAL_CHANGES_USE_CHANGE_INVOICETEXT'"
          ></app-check-box>
        </div>
        <div class="col-12 col-md-5 col-lg-4">
          <app-check-box
            [control]="changeRetroactiveArticle"
            [helpText]="'LEASE_AGREEMENT.HELP_TEXT.RENTAL_CHANGES_USE_CHANGE_RETROACTIVE_ARTICLE'"
          ></app-check-box>
        </div>
      </div>
    }
    @if (this.form.controls['useRetroactiveRent'].value) {
      <div class="row">
        <div class="col-12 col-md-5 col-lg-4"></div>
      </div>
    }
    @if (this.form.controls['useRetroactiveRent'].value) {
      <div class="row">
        <div class="col-12 col-md-5 col-lg-4">
          @if (this.form.controls['changeInvoiceText'].value) {
            <app-text-box
              [control]="newInvoiceText"
              [helpText]="'LEASE_AGREEMENT.HELP_TEXT.RENTAL_CHANGES_NEW_INVOICETEXT'"
            ></app-text-box>
          }
        </div>
        <div class="col-12 col-md-5 col-lg-4">
          @if (this.form.controls['changeRetroactiveArticle'].value) {
            <app-autocomplete
              [control]="form.controls['retroactiveArticle']"
              [itemsSource]="retroactiveArticles"
              [helpText]="'LEASE_AGREEMENT.HELP_TEXT.RENTAL_CHANGES_RETROACTIVE_ARTICLE'"
            ></app-autocomplete>
          }
        </div>
      </div>
    }
  </section>
}

@if (isPreview) {
  <section>
    @if (previewLeases) {
      <h1 class="d-none d-md-block header list-header">
        {{ 'LEASE_AGREEMENT.RENTAL_CHANGES_CHANGED_AGREEMENTS' | translate }}
      </h1>
    }
    @if (previewLeases) {
      <app-list-view
        [itemsSource]="rentalChanges"
        [columnDefinition]="rentalChangeColumnDefinitions"
        [preferencesKey]="'rent.rental-changes.preview-leases'"
        >
      </app-list-view>
    }
    @if (previewObjects) {
      <h1 class="d-none d-md-block header list-header">
        {{ 'LEASE_AGREEMENT.RENTAL_CHANGES_CHANGED_OBJECTS' | translate }}
      </h1>
    }
    @if (previewObjects) {
      <app-list-view
        [itemsSource]="rentalObjectChanges"
        [columnDefinition]="objectRentalChangeColumnDefinitions"
        [preferencesKey]="'rent.rental-changes.preview-objects'"
        >
      </app-list-view>
    }
    <div>
      @if (canChange) {
        <button class="btn btn-outlined" (click)="save()">{{ 'SAVE_BTN' | translate }}</button>
      }
      <button class="btn btn-outlined ml-2" (click)="cancel()">{{ 'CANCEL_BTN' | translate }}</button>
    </div>
  </section>
}
